module.exports = __webpack_public_path__ + "img/advanced-version.31dbafec.png";